import { DialogState, DialogTemplate } from 'inpock-ui-react';
import { atom } from 'recoil';

const SampleTemplate = {
  render: () => (
    <DialogTemplate
      moduleName=""
      title="Dialog Title 🗑"
      classSuffix=""
      message="Dialog Text message"
    />
  ),
};

export const initialDialogState: DialogState = {
  visible: false,
  template: SampleTemplate.render(),
  close: {
    text: '닫기',
    type: 'default',
    loading: false,
  },
  confirm: undefined,
};

export const dialogState = atom({
  key: 'dialogState',
  default: initialDialogState,
});
